import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { loading$ } from "../services/common/states";
import { selectUser } from "../services/store/userSlice";
import { useNavigate } from "react-router";

import App from "./App";

const Application = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
    loading$.subscribe((v) => {
      setIsLoading(v);
    });
  }, [user]);

  return (
    <Fragment>
      <App
        isLoading={isLoading}
      />
    </Fragment>
  );
};

export default Application;
